import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const AboutPage = () => {
  return (
    <section id="about" className="about-page">
      <Container>
        <Row className="align-items-center">
          <Col md={6}>
            <div className="about-content">
              <h1>About Us</h1>
              <p>
                We are a leading textile company dedicated to innovation and quality. 
                Our commitment to excellence drives us to deliver the best solutions 
                for our clients across the globe.
              </p>
              <p>
                With years of experience in the industry, we combine traditional 
                craftsmanship with modern technology to create exceptional textile 
                products that meet the highest standards.
              </p>
            </div>
          </Col>
          <Col md={6}>
            <div className="about-image">
              {/* Add your about image here */}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutPage;